/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect } from "react";
import { Col, Row } from "react-awesome-styled-grid";
import { Box, FlexContainer, theme } from "@nordcloud/gnui";
import { useCustomer } from "~/context";
import {
  ResourcesCard,
  ResourceGroupsCard,
  PlansCard,
  AccountsCard,
  SummaryCard,
} from "./components";
import { useGetDashboardResources } from "./hooks";

export function Dashboard() {
  const { customer } = useCustomer();
  const {
    getResources,
    resourcesStatus,
    resourcesOsList,
    count: resourcesTotal,
    loading,
  } = useGetDashboardResources();

  useEffect(() => {
    getResources();
  }, [getResources, customer]);

  return (
    <>
      <Row>
        <Col>
          <Box mb={theme.spacing.spacing02}>
            <FlexContainer gap={theme.spacing.spacing04} alignItems="stretch">
              <ResourcesCard
                items={resourcesStatus}
                count={resourcesTotal}
                loading={loading}
              />
              <ResourceGroupsCard />
              <PlansCard />
              <AccountsCard />
            </FlexContainer>
          </Box>
        </Col>
      </Row>
      <Row>
        <Col>
          <FlexContainer
            gap={theme.spacing.spacing02}
            css={{ width: "100%", alignItems: "stretch" }}
          >
            <Box>Last Patching Status</Box>
            <SummaryCard
              title="Resources by Operating System"
              items={resourcesOsList}
              hasChart
            />
            <Box>Attention Needed</Box>
          </FlexContainer>
        </Col>
      </Row>
    </>
  );
}
